import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoute from "./auth/ProtectedRoute";

import Home from "./pages/Home";
import Events from "./pages/Events";
import EventDetails from "./pages/EventDetails";

import Bookings from "./pages/Bookings";
import Memberships from "./pages/Memberships";
import Settings from "./pages/Settings";

import AuthStart from "./pages/auth/AuthStart";
import AuthEmail from "./pages/auth/AuthEmail";
import AuthLogin from "./pages/auth/AuthLogin";
import AuthSignup from "./pages/auth/AuthSignup";
import BookSeat from "./pages/BookSeat";
import BookMeetingRoom from "./pages/BookMeetingRoom";
import BookSpace from "./pages/BookSpace";



export default function App() {
  return (
    <Routes>
      {/* Auth Flow */}
      <Route path="/auth" element={<AuthStart />} />
      <Route path="/auth/email" element={<AuthEmail />} />
      <Route path="/auth/login" element={<AuthLogin />} />
      <Route path="/auth/signup" element={<AuthSignup />} />

      {/* Dashboard */}
      <Route path="/" element={<ProtectedRoute><Home /></ProtectedRoute>} />
      <Route path="/spaces/book-seat" element={<BookSeat />} />
      <Route path="/spaces/book-meeting-room" element={<BookMeetingRoom />} />
      <Route path="/spaces/book-space" element={<BookSpace />} />
      <Route path="/bookings" element={<ProtectedRoute><Bookings /></ProtectedRoute>} />
      <Route path="/events" element={<ProtectedRoute><Events /></ProtectedRoute>} />
      <Route path="/events/:id" element={<ProtectedRoute><EventDetails /></ProtectedRoute>} />
      <Route path="/memberships" element={<ProtectedRoute><Memberships /></ProtectedRoute>} />
      <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />

      {/* Old routes */}
      <Route path="/login" element={<Navigate to="/auth" replace />} />
      <Route path="/register" element={<Navigate to="/auth" replace />} />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
